import { EbrService } from 'src/app/core/services/ebr.service';
import { Component, OnInit, OnDestroy, Input, Inject } from '@angular/core';
import { AlertService } from 'src/app/core/services/alert.service';
import { Alert } from 'src/app/global/types';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { TVDService } from 'src/app/features/total-value-delivery/services/tvd.service';
import { TVDModel } from 'src/app/features/total-value-delivery/types/tvd-model';
import { Subscription } from 'rxjs';
import { ServiceInsightsService } from 'src/app/features/service-insights/services/service-insights-service.service';
import {
  AddedServiceMetric,
  ServiceInsightsPresentationData,
  ServiceInsightsPresentationDataObject,
} from 'src/app/features/service-insights/types/service-insight-types';
import { TVDDistributorService } from 'src/app/features/total-value-delivery/services/tvd-distributor.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { FiltersService } from 'src/app/core/services/filters.service';
import { eroiIds, tvdGroupIds, TvdMetricData, TVDMetricGroupResponse, TvdValuePillar } from 'src/app/features/total-value-delivery/types/tvd-types';
import { PresentationService } from 'src/app/core/services/presentation.service';
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';
import { Division, Region } from 'src/app/core/services/ebr-api-client/ebr-api-client.g';
import { PresentationType } from 'src/app/core/types/presentation-types';
import { updatePresentationConfigurationOptionsForAPInstitutional, updatePresentationConfigurationOptionsForLAInstitutional, getAvailablePresentationTypes, PresentationConfig } from 'src/app/features/filter-panel/types/filters';
import { TemplateTranslationsService } from 'src/app/core/services/template-translations.service';



@Component({
    selector: 'app-download-presentation-button',
    templateUrl: './download-presentation-button.component.html',
    styleUrls: ['./download-presentation-button.component.css'],
    standalone: false
})
export class DownloadPresentationButtonComponent implements OnInit, OnDestroy {
  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;

  totalSales: any;
  totalValueDeliveredDollars: any;
  programData: any;
  tvdMetricAdded: any;
  tvdProgramSubscription: Subscription | undefined;
  tvdMetricAddedSubscription: Subscription | undefined;
  selectedBenchmarkOption: string = '';

  constructor(
    private ebrService: EbrService,
    private alertService: AlertService,
    private mixpanelService: MixpanelService,
    private filtersService: FiltersService,
    private tvdService: TVDService,
    private tvdDistributorService: TVDDistributorService,
    private serviceInsightsService: ServiceInsightsService,
    private presentationService: PresentationService,
    private templateTranslationService: TemplateTranslationsService,
    @Inject(FEATURE_FLAGS) private featureFlags: FeatureFlags,
  ) {}

  @Input() name: string | undefined;
  @Input() presentationType: string = '';

  tvdSubscription: Subscription | undefined;
  tvdModel: TVDModel | undefined;
  tvdResponse: TVDMetricGroupResponse[] | undefined;

  disabled: boolean = false;
  pptDownloadSubscripiton: Subscription | undefined;

  @Input() commentsJson: JSON | undefined;
  isHideButton:boolean=false;
  hasPestMetricsSelected:boolean = true;
  showBenchmark: boolean = false;
  benchmarkTitle: string = '';
  pestOrderMetricsMap: Map<string, number> = new Map([
    ['Locations Serviced',1],
    ['Service Visits',2],
    ['Pest ESRs', 3],
    ['Pest Findings', 4],
    ['Sanitation Findings', 5],
    ['Structural Findings', 6],
    ['Prep Findings', 7],
    ['Pest Catches',8],
  ]);

  showTemplateAndTranslationSelection: boolean = false;

  availablePresentationTypes: PresentationConfig[] = [];

  ngOnInit(): void {
    updatePresentationConfigurationOptionsForLAInstitutional(this.featureFlags.enableTVDForLAInstitutional)
    updatePresentationConfigurationOptionsForAPInstitutional(this.featureFlags.enableTVDForAPInstitutional);
    this.name = 'Download Presentation';

    this.filtersSubscription = this.filtersService.selectedFiltersObservable.subscribe(f => {
      this.filters = f;
      });
  }

  private getAvailablePresentationTypesForCurrentFilters() {
    if(this.filters?.division && this.filters?.regions){
        //Distributor user does not select regions but the division is treated like Region.NA
        let regions = this.filters.division as Division == Division.Distributor ? [Region.NA] : this.filters.regions as Region[];
        this.availablePresentationTypes = getAvailablePresentationTypes(this.filters.division as Division, regions);
        let multipleTranslationsAvailable: boolean = false;
        // If only one presentationType is available, check if there are multiple translations available for that template
        if(this.availablePresentationTypes.length == 1){
          multipleTranslationsAvailable = this.templateTranslationService.getAvailableTranslationsByTemplateCode(this.availablePresentationTypes[0].presentationType).length >1;
        }

        this.showTemplateAndTranslationSelection = this.availablePresentationTypes.length > 1 || multipleTranslationsAvailable;    
    }
  }

  ngOnDestroy(): void {
    //unsubscribe from subscriptions
    this.tvdSubscription?.unsubscribe();
    this.programData?.unsubscribe();
    this.tvdMetricAdded?.unsubscribe();
    this.filtersSubscription?.unsubscribe();
    this.pptDownloadSubscripiton?.unsubscribe();
  }

  private async handleTvdDataSubscription() {
    if (this.filters){
      // subscribe to tvd data
      this.tvdSubscription = this.tvdService.tvdObservable.subscribe( async (t) => {
          this.tvdModel = t;
      });

      this.tvdService.setDivision(this.filters.division);

      // Make request to tvd endpoint, set tvd data to default model if there is no tvd data
      if (this.tvdModel == undefined || this.tvdModel.tvdMetricSelections == undefined || this.tvdModel.addedMetrics == undefined) {
        // Sets the tvd observable to the default tvd model which we have subscribed to above
        await this.tvdService.setToDefaultTVDModel();
      }

      // subscribe to program data
      this.tvdService.getProgramData().subscribe((data) => {
        this.programData = data;
      });

      // subscribe to tvd metric data
      this.tvdService.getTvdMetricData().subscribe((data) => {
        if(data && data.length > 0) {
          this.tvdMetricAdded = data?.join(', ');
          if(this.tvdService.getCountMetric()== 0) this.tvdMetricAdded = "No Metric Added"
        }
        else {
          // if no tvd metric data is available, set tvd metric data to default
          if(this.tvdModel && this.tvdModel.tvdMetricSelections[0].indvMetrics.length > 0) {
            this.tvdMetricAdded = "Greenhouse Gases, Assets Repair, Productivity, Assets Replacement, Energy, Plastic Waste, Water, Cardboard Waste, Employee Safety, Cost Avoidance";
          } else {
            this.tvdMetricAdded = "No Metric Added";
          }
        }
      });
    }
  }


  setTVDValuesForMixpanel() {
    if (this.tvdModel && this.tvdModel.tvdMetricSelections) {
      // Extract Total Sales and Overall TVD metrics from response
      const defaultId = this.filters?.division === 'Pest' ? tvdGroupIds.PEST : tvdGroupIds.DEFAULT;
      let defaultTVDResponse = this.tvdModel.tvdResponse.find(group => group?.id === defaultId);
      this.totalSales = defaultTVDResponse?.summMetrics.find(metric => metric?.id === eroiIds.TOTALSALES)?.monetaryContribution;
      this.totalValueDeliveredDollars = defaultTVDResponse?.summMetrics.find(metric => metric?.id === eroiIds.TOTALVALUEDELIVERED)?.monetaryContribution;
    }
    else { //ideally not reached
      this.totalSales = "Not Set";
      this.totalValueDeliveredDollars = "Not Set";
    }
  }

  /**
   * Validates that no value pillar exceeds the maximum allowed metrics before generating the PPT.
   *
   * If the user has committed an explicit selection via "Add to Presentation", the limit is
   * already enforced during the selection flow (checkTotalTilesSelected), so no re-check
   * is needed here.
   *
   * Otherwise the total available tiles per pillar (standard + all saved custom tiles) are
   * checked, and the user is prompted to use "Add to Presentation" if any pillar exceeds the limit.
   *
   * @returns true if download can proceed, false if a limit is exceeded.
   */
  private validateMetricsPerPillarOnDownload(): boolean {
    const MAX_TILES_PER_PILLAR = 8;

    if (this.tvdService.hasExplicitSelections) {
      return true;
    }

    for (const pillar of Object.values(TvdValuePillar)) {
      if (this.tvdService.countTotalMetricsPerValuePillar(pillar) > MAX_TILES_PER_PILLAR) {
        window.alert(`Only ${MAX_TILES_PER_PILLAR} metrics can be displayed in the Powerpoint per value pillar.\n\nMost recently added metric will not be shown in the Powerpoint but is included in the total.\n\nUse the "Add to Presentation" button to adjust which metrics will be visible.`);
        return false;
      }
    }

    return true;
  }

  async onDownloadPresentation() {
    if (!this.disabled) {
      if (!this.validateMetricsPerPillarOnDownload()) {
        return;
      }

      this.getAvailablePresentationTypesForCurrentFilters();

      switch(this.filters?.division){
        case Division.Distributor:
          await this.onDownloadDistributorPresentation();
          break;
        case Division.Pest:
          await this.onDownloadPestPresentation();
          break;
        default:
          await this.onDownloadInstQsrFrsPresentation();
          break;
      }
    }
  }

  async onDownloadDistributorPresentation() {
    if (this.filters != undefined) {
      try{
        // Subscribe to observable containing tvd data
        this.tvdSubscription = this.tvdDistributorService.tvdObservable.subscribe( async (t) => {
          this.tvdModel = t;
        });

        this.tvdService.setDivision(this.filters.division);

        // if there is tvd data not loaded already, make request to tvd endpoint, set tvd data to default model
        if (this.tvdModel == undefined || this.tvdModel.tvdMetricSelections == undefined || this.tvdModel.tvdMetricSelections.length == 0) {
          // Sets the tvd observable to the default tvd model which we have subscribed to above
          await this.tvdDistributorService.setDefaultTVDModel();
        };

        let selectedFilterOptions = this.tvdDistributorService.getSelectedFilterOptions();
        let selectedBrandGroup = this.tvdDistributorService.getSelectedBrandGroup();

        if(this.tvdModel){
          this._trackDistributorDownload('Download Presentation clicked', this.tvdModel.tvdMetricSelections);
          this.disabled = true;
          this.name = 'Processing Download...';

          let downloadPPT = this.ebrService.getDistributorPresentation(
            this.filters,
            this.tvdModel.tvdMetricSelections,
            selectedBrandGroup,
            selectedFilterOptions
          );

          const fileData = await downloadPPT
          .then((response) => {
            const { data } = response;
            return data;
          })

          this.executeBrowserDownload(fileData);
        }
      } catch (error) {
        this.alertService.addAlert(this.createPresentationErrorAlert());
      }

      this.name = 'Download Presentation';
      this.disabled = false;

    }
  }

  async onDownloadPestPresentation() {
    if (this.filters != undefined) {
      try{
        // Show benchmark component for Pest division
        this.showBenchmark = true;
        this.benchmarkTitle = 'Pest Division';
      }catch (error) {
        this.alertService.addAlert(this.createPresentationErrorAlert());
      }
    }
  }

  async onDownloadInstQsrFrsPresentation() {
    if (this.filters != undefined) {
      try{
        this.getAvailablePresentationTypesForCurrentFilters();
        if(!this.showTemplateAndTranslationSelection){
          this.proceedWithInstQsrFrsPresentation();
        }
      } catch (error) {
        this.alertService.addAlert(this.createPresentationErrorAlert());
      }
    }
  }

  private async proceedWithInstQsrFrsPresentation() {
    this.disabled = true;
    this.name = 'Processing Download...';
    // if there is tvd data not loaded already, make request to tvd endpoint, set tvd data to default model
    // for AP Institutional, we skip this step as the presentation download does not require tvd data and this avoids an unnecessary request to the tvd endpoint
    if(this.isTVDEnabledForRegion()){
      await this.handleTvdDataSubscription();
    }

    this.setTVDValuesForMixpanel();

    if (this.filters != undefined && this.tvdModel != undefined) {
      let shouldDownload = true;

      this._trackDownload('Download Presentation clicked');

      let downloadPPT = this.ebrService
          .getPresentation(
            this.filters,
            this.tvdModel,
            this.serviceInsightsService.getAddedServiceMetrics(),
            this.serviceInsightsService.getAddedTopBottomLocs(),
            this.serviceInsightsService.getServiceInsightsDataForPresentation(),
            (this.filters.regions?.length ?? 0) > 1 
          )

      const fileData = await downloadPPT
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        shouldDownload = false;
        console.log(JSON.stringify(error));
        this.alertService.addAlert(this.createPresentationErrorAlert());
      });

      if (shouldDownload) {
        this.executeBrowserDownload(fileData);
      }

      // Capturing User Service Insights
      if (this.getUserInsightsIfNotEmpty()) this.captureUserServiceInsights();
    }
    this.name = 'Download Presentation';
    this.disabled = false;
  }

  private async proceedWithPestDownload() {
    if (this.filters != undefined) {
      try{
        this.disabled = true;
        this.name = 'Processing Download...';
        await this.handleTvdDataSubscription();
        this.serviceInsightsService?.isPestMetricsSelected?.subscribe((metrics:Map<string,boolean>)=>{
          this.hasPestMetricsSelected = Array.from(metrics.values()).some(value => value === true);
        });
        this.tvdSubscription = this.tvdService.tvdObservable.subscribe( async (t) => {
          this.tvdModel = t;
        });

        // Set the selected benchmark option to thirdLevelContractFilter
        if (this.selectedBenchmarkOption) {
          this.filters.thirdLevelContractFilter = [this.selectedBenchmarkOption];
        }
        if(this.hasPestMetricsSelected && this.tvdModel != undefined){
          this.setTVDValuesForMixpanel();
          this._trackDownload('Download Presentation clicked');
          let downloadPPT = this.ebrService
          .getPestPresentation(
            this.tvdModel,
            this.filters,
            this.sortPestMetricsByPredefinedOrder(this.serviceInsightsService.getPestServiceMetrics()),
          );
          const fileData = await downloadPPT
          .then((response) => {
            const { data } = response;
            return data;
          })

          this.executeBrowserDownload(fileData);
        }
        else{
          alert('Please choose at least one metric before clicking the download button.');
        }
      }catch (error) {
        this.alertService.addAlert(this.createPresentationErrorAlert());
      }
    }
    this.name = 'Download Presentation';
    this.disabled = false;
  }

  // Methods to handle benchmark component events
  onBenchmarkClose() {
    this.showBenchmark = false;
  }

  onBenchmarkProceed(selectedOption: string) {
    this.showBenchmark = false;
    // Store the selected benchmark option
    this.selectedBenchmarkOption = selectedOption;

    this.proceedWithPestDownload();
  }

  // Methods to handle template and translation selection events
  onTemplateAndTranslationClose() {
    this.showTemplateAndTranslationSelection = false;
  }

  onTemplateAndTranslationProceed(selectedOptions: { template: string | undefined, translation: string | undefined }) {
    this.showTemplateAndTranslationSelection = false;
    this.filters!.presentationType = selectedOptions.template;
    this.filters!.translation = selectedOptions.translation;
    //When selecting multiple regions or single-LA Institutional, a modal appears for template and translation options.
    //When selecting via modal, isMultiRegional is true for multi-region and false for single-LA.
    //For multi-region PPTs in the EU, the TVD Placemat Product Detail Appendix will be changed; for single region, it is same as before.

    this.proceedWithInstQsrFrsPresentation();
  }

  createPresentationErrorAlert(): Alert {
    const id = Math.random() * 25;
    const message =
      'The presentation download has encountered an error. Please try again. If another error occurs, you may need to apply more filters to the data.';
    return { id: id, message: message };
  }

  executeBrowserDownload(fileData: BlobPart) {
    const url = window.URL.createObjectURL(new Blob([fileData]));

    const link = document.createElement('a');
    link.href = encodeURI(url);
    link.setAttribute('download', 'EBR-data-' + new Date() + '.pptx');
    document.body.appendChild(link);
    link.click();
  }

  private _trackDownload(eventName: string): void {
    this.mixpanelService.track(eventName, {
      Division: this.filters?.division,
      DataView: this.filters?.dataView,
      regionSelected: this.filters?.regions,
      countriesSelected: this.filters?.countries,
      H5s: this.filters?.topLevelContractGroup,
      H7s: this.filters?.secondLevelContractFilter,
      customerNumbersSelected: this.filters?.accts,
      periodSelected: this.filters?.period,
      "Custom Date Range": this.filters?.dateRange,
      templateSelected: this.presentationService.getSelectedPresentationTypeCode(),
      templateTranslationSelected:
        this.filters?.translation != ''
          ? this.filters?.presentationType
          : '',
      userInsights: this.getUserInsightsIfNotEmpty()
        ? this.serviceInsightsService.getServiceInsightsDataForPresentation()
        : [],
      TvdMetricAdded: this.tvdMetricAdded,
      Program: this.programData,
      TotalValueDelivered: this.totalValueDeliveredDollars,
      TotalSales: this.totalSales,
    });
  }

  private _trackDistributorDownload(eventName: string, tvdMetricSelections: TVDMetricGroupResponse[]): void {
    // Retrieve/calculate metrics needed for mixpanel event
    const metrics = tvdMetricSelections.reduce<TvdMetricData[]>((acc, current) => acc.concat(current.indvMetrics), []);
    const metricIds = metrics.map(metric => metric.id.charAt(0).toUpperCase() + metric.id.slice(1));
    let defaultTvd = tvdMetricSelections.find(group => group.id === tvdGroupIds.DEFAULT);

    this.mixpanelService.track(eventName, {
      'Division': this.filters?.division,
      'DataView': this.filters?.dataView,
      'Partner Groups': this.filters?.topLevelContractGroup,
      'Distributor Groups': this.filters?.secondLevelContractFilter,
      'Accounts': this.filters?.accts,
      'Period': this.filters?.period,
      'Custom Date Range': this.filters?.dateRange,
      'TvdMetrics': metricIds,
      'TotalValueDelivered': defaultTvd?.summMetrics.find(metric => metric.id === eroiIds.TOTALVALUEDELIVERED)?.monetaryContribution,
      'TotalSales': defaultTvd?.summMetrics.find(metric => metric.id === eroiIds.TOTALSALES)?.monetaryContribution,
    });
  }

  private getUserInsightsIfNotEmpty(): boolean {
    return Object.values(
      this.serviceInsightsService.getServiceInsightsDataForPresentation()
    ).some((v) => v.length > 0)
      ? true
      : false;
  }

  private captureUserServiceInsights() {
    let itemsToCapture: ServiceInsightsPresentationDataObject[] =
      this.buildUserServiceInsights();

    if (itemsToCapture.length > 0) {
      this.ebrService.captureUserInsights(this.filters!, itemsToCapture);
    }
  }

  public buildUserServiceInsights(): ServiceInsightsPresentationDataObject[] {
    let itemsToCapture: ServiceInsightsPresentationDataObject[] = [];
    let insights: ServiceInsightsPresentationData =
      this.serviceInsightsService.getServiceInsightsDataForPresentation();

    insights.addedIssuesFindings.forEach((item) => {
      pushIfNotEmpty(item);
    });

    insights.addedOverallFindings.forEach((item) => {
      pushIfNotEmpty(item);
    });

    insights.addedRecurringIssuesFindings.forEach((item) => {
      pushIfNotEmpty(item);
    });

    function pushIfNotEmpty(item: ServiceInsightsPresentationDataObject) {
      if (item.NextSteps.length || item.Implications.length) {
        itemsToCapture.push(item);
      }
    }
    return itemsToCapture;
  }

  getNotEmptyValueKeys<T extends Record<string, string>>(obj: T): string[] {
    return Object.keys(obj).filter(key => obj[key] !== '0' && obj[key] !== '' && obj[key] !== 'N/A');
  }

    /**
   * Sorts metrics based on the predefined order in pestOrderMetricsMap
   * @param metrics - The metrics array to sort
   * @returns Sorted metrics array with renamed "Pest ESR" to "Pest ESRs"
   */
    private sortPestMetricsByPredefinedOrder(metrics: AddedServiceMetric[]): AddedServiceMetric[] {
      if (!metrics || !metrics.length) return [];

      // First rename "Pest ESR" to "Pest ESRs" for display in PPT (on UI it remains "Pest ESR")
      const renamedMetrics = metrics.map(metric => {
        if (metric.metricDataName === 'Pest ESR') {
          return {
            ...metric,
            metricDataName: 'Pest ESRs'
          };
        }
        return metric;
      });

      // Then sort by predefined order (using "Pest ESRs" for lookup)
      return renamedMetrics.sort((a, b) => {
        const orderA = this.pestOrderMetricsMap.get(a.metricDataName) ?? 999;
        const orderB = this.pestOrderMetricsMap.get(b.metricDataName) ?? 999;
        return orderA - orderB;
      });
    }

  // Regions that require a feature flag to be enabled before TVD data/presentation is available.
  private static readonly FLAG_GATED_REGIONS: string[] = [Region.AP, Region.LA, Region.IMEA];

  private isTVDEnabledForRegion(): boolean {
    const regions = this.filters?.regions;
    const isInstitutional = this.filters?.division == Division.Institutional;
    const singleRegion = regions?.length === 1 ? regions[0] : undefined;

    const isRegionDisabled = isInstitutional && !!singleRegion &&
      DownloadPresentationButtonComponent.FLAG_GATED_REGIONS.includes(singleRegion) &&
      !this.isRegionTvdFeatureEnabled(singleRegion);

    if (isRegionDisabled) {
      this.filters!.presentationType =
      (this.filters!.presentationType == undefined || this.filters!.presentationType.length == 0) ? PresentationType.Other : this.filters!.presentationType;

      // Set the TVD model to default values to avoid any issues with undefined data in
      // the presentation download since AP Institutional presentation should work without TVD data and this flag
      // being false indicates that there is no tvd data for AP Institutional. This ensures that the presentation download still works for AP Institutional with default TVD values even when there is no TVD data.
      this.tvdModel = new TVDModel(
        [{ id: 'default_tvd', brandGroup: 'all', indvMetrics: [], summMetrics: [] }],
        [{ id: 'default_tvd', brandGroup: 'all', indvMetrics: [], summMetrics: [] }],
        [{ id: 'default_tvd', brandGroup: 'all', indvMetrics: [], summMetrics: [], groupSelected: false, title: 'Default' }],
        new Map (),
        []
      );
    }
    return !isRegionDisabled;
  }

  private isRegionTvdFeatureEnabled(region: string): boolean {
    switch (region) {
      case Region.LA: return this.featureFlags.enableTVDForLAInstitutional;
      case Region.AP: return this.featureFlags.enableTVDForAPInstitutional;
      case Region.IMEA: return this.featureFlags.enableTVDAndSPForIMEAInstitutional;
      default: return false;
    }
  }
}
